<template>
  <v-card>
    <v-list-item>
      <bookie-icon
        :bookie="race.bookie"
        :size="30"
        :top="true"
        @click="onIconClicked"
      />
      <span class="race-icon">
        <greyhounds v-if="race.type === 'GREYHOUND'" />
        <harness v-else-if="race.type === 'HARNESS'" />
        <horses v-else />
      </span>
      <v-list-item-content>
        <v-list-item-title class="subtitle-1">
          {{ race.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <span>{{ formatState(race.venueState) }}</span>
          <span class="float-right">
            <countdown-timer :time="race.startTime" />
          </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="panel-bottom">
          <span class="monitoring-state" v-if="tradedVolume">
            Vol: $ {{ formatCurrency(tradedVolume) }}
          </span>
          <span class="monitoring-book" v-if="bookieMarket">
            Market: {{ bookieMarket }} %
          </span>
          <span class="float-right">
            <v-menu v-if="menu.length">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="darken-2" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in menu"
                  :key="index"
                  @click="item.action(race)"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <template v-if="showSelections">
      <v-tabs v-model="tab" height="30" color="black">
        <v-tab v-for="m in markets" :key="m.type">{{
          formatMarketType(m.type)
        }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="m in markets" :key="race.id + m.type">
          <v-list dense>
            <runner-item
              v-for="s of selections.filter(s => s && s.marketType === m.type)"
              :key="s.id + m.type"
              :selection="s"
              :race="race"
              :market="m"
            />
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-card>
</template>

<script>
import { marketType, state } from "../lib/formatting";
import BookieIcon from "./BookieIcon";
import CountdownTimer from "./CountdownTimer";
import RunnerItem from "./RunnerItem";
import Constants from "../lib/constants";
import Greyhounds from "../icons/Greyhounds";
import Harness from "../icons/Harness";
import Horses from "../icons/Horses";

export default {
  name: "RacePanel",
  components: {
    RunnerItem,
    CountdownTimer,
    BookieIcon,
    Greyhounds,
    Harness,
    Horses
  },
  props: ["race", "showSelections", "menu"],
  data() {
    return {
      tab: null
    };
  },
  computed: {
    selections() {
      return this.$store.getters.selectionsByRaceID(
        this.race.bot,
        this.race.id
      );
    },
    markets() {
      return Object.values(this.race.markets);
    },
    tradedVolume() {
      const market = Object.values(this.race.markets)[this.tab];
      if (!market) return null;

      const vol = this.$store.getters.getBetfairVolume(
        this.race.bot,
        market.betfairID
      );
      if (!vol) return 0;

      return vol;
    },
    bookieMarket() {
      const market = Object.values(this.race.markets)[this.tab];
      if (!market) return null;

      const mktVal = this.$store.getters.getBookieMarket(
        this.race.bot,
        this.race.id,
        market.type
      );
      if (!mktVal) return 0;

      return (mktVal * 100).toFixed(1);
    }
  },
  methods: {
    onIconClicked() {
      this.$emit("iconClicked");
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatCurrency(amt) {
      if (!amt) return "";

      return this.numberWithCommas(Math.floor(amt));
    },
    formatMarketType: marketType,
    formatState: state,
    secondsRemaining() {
      return 6000;
    },
    iconColor(bookie) {
      return Constants.BOOKIE_ICONS[bookie].foreground;
    },
    iconBackground(bookie) {
      return Constants.BOOKIE_ICONS[bookie].background;
    },
    iconInitials(bookie) {
      return Constants.BOOKIE_ICONS[bookie].initials;
    },
    transformTime(props) {
      props.formatted = props.seconds;
      console.log(props);
      return props;
    }
  }
};
</script>

<style lang="scss">
.monitoring-state {
  position: relative;
  top: 5px;
}
.monitoring-book {
  position: relative;
  top: 5px;
  left: 28px;
}

.panel-bottom {
  height: 20px;
}

.race-icon {
  left: 15px;
  bottom: 5px;
  position: absolute;
}
</style>
